export default __webpack_public_path__ + "static/media/personal.a12431f7.svg";